module.exports = __webpack_public_path__ + "img/Incoming_data_blue.9efd50e4.svg";